import React from 'react';
import { FormattedMessage } from 'react-intl';

import TrustyValuePropGraphic from 'images/TrustyValuePropGraphic.png';
import ValuePropsModal from 'components/paywall/ValuePropsModal';

type TrustyValuePropsModalProps = {
  onRequestClose: () => void;
};

const title = (
  <FormattedMessage
    id="Trusty.valuePropsModalNew.title"
    defaultMessage="Customer Portal"
    description="Title for New Trusty Value Props Modal"
  />
);

const description = (
  <FormattedMessage
    id="Trusty.valuePropsModalNew.description"
    defaultMessage="Give access to Trusty, the new customer portal from CompanyCam, and coordinate projects like never before."
    description="Description for New Trusty Value Props Modal"
  />
);
const checklistItems = [
  <FormattedMessage
    id="Trusty.valuePropsModalNew.valueProp1"
    defaultMessage="Receive customer photos in CompanyCam"
    description="Value Prop for Trusty Feature"
  />,
  <FormattedMessage
    id="Trusty.valuePropsModalNew.valueProp2"
    defaultMessage="Have customers pay you directly from Trusty"
    description="Value Prop for Trusty Feature"
  />,
  <FormattedMessage
    id="Trusty.valuePropsModalNew.valueProp3"
    defaultMessage="Get notifications for customer activity"
    description="Value Prop for Trusty Feature"
  />,
];

const TrustyValuePropsModal = ({
  onRequestClose,
}: TrustyValuePropsModalProps) => {
  return (
    <ValuePropsModal
      checklistItems={checklistItems}
      title={title}
      description={description}
      image={TrustyValuePropGraphic}
      onRequestClose={onRequestClose}
      trackingAction="trusty_value_prop_opened"
      dataTestId="trusty"
    />
  );
};

export default TrustyValuePropsModal;
